import LegalBody from "./LegalBody";
import { TERMS_SECTIONS, TERMS_UPDATED } from "./legal_content";

export default function Terms() {
  return (
    <LegalBody
      title="Kullanım Koşulları"
      updated={TERMS_UPDATED}
      sections={TERMS_SECTIONS}
    />
  );
}
